import { render, staticRenderFns } from "./OptionsCategoriesList.vue?vue&type=template&id=1a456cd0&"
import script from "./OptionsCategoriesList.vue?vue&type=script&lang=js&"
export * from "./OptionsCategoriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports